{
  "aiGeneratedAnswer": "AI-genereret svar",
  "allCategories": "Alle kategorier",
  "appliedFiltersToCurrentSearch": "Anvendte filtre til den aktuelle søgning",
  "apply": "Anvende",
  "applyFilters": "Anvend filtre",
  "autocompleteOptionsFound_one": "{{count}}{{label}} autofuldførelsesmulighed fundet.",
  "autocompleteOptionsFound_other": "{{count}}{{label}} autofuldførelsesmuligheder fundet.",
  "autocompleteSuggestion": "autofuldførelsesforslag: {{suggestion}}",
  "autocompleteSuggestionsFound_one": "{{count}} autofuldførelsesforslag fundet.",
  "autocompleteSuggestionsFound_other": "{{count}} autofuldførelsesforslag fundet.",
  "basedOnYourDevice": " (baseret på din enhed)",
  "basedOnYourInternetAddress": " (baseret på din internetadresse)",
  "categoriesText_one": "Følgende kategori gav resultater for - <strong>{{query}}</strong>",
  "categoriesText_other": "Følgende kategorier gav resultater for - <strong>{{query}}</strong>",
  "clearAll": "Ryd alle",
  "clearMinAndMax": "Ryd maks og min",
  "clearTheRangeToSelectOptions": "Ryd rækkevidden for at vælge indstillinger.",
  "clearTheSearchBar": "Ryd søgefeltet",
  "conductASearch": "Foretage en søgning",
  "currentLocation": "Nuværende placering",
  "didYouMean": "Mente du <button>{{correctedQuery}}</button>",
  "dropDownScreenReaderInstructions": "Når autoudfyldningsresultater er tilgængelige, brug pil op/ned for at gennemgå og Enter for at vælge.",
  "feedback": "Feedback",
  "filterGroupSearchInputLabel": "Søg i valgmuligheder for {{title}}",
  "invalidRange": "Ugyldigt rækkevidde",
  "max": "Maks",
  "min": "Min",
  "navigateToTheNextResultsPage": "Naviger til den næste resultatside",
  "navigateToThePreviousResultsPage": "Naviger til den tidligere resultatside",
  "noAutocompleteOptionsFound": "0 autofuldførelsesmuligheder fundet.",
  "noAutocompleteSuggestionsFound": "0 forslag til autofuldførelse fundet.",
  "noResultsFoundIn": "Ingen resultater fundet i {{currentVerticalLabel}}.",
  "paginationPage": "side {{pageNumber}}",
  "pagination": "Pagination",
  "readMoreAbout": "Læs mere om <a>{{name}}</a>",
  "recentSearch": "nylig søgning: {{query}}",
  "recentSearchesFound_one": "{{count}} seneste søgning fundet.",
  "recentSearchesFound_other": "{{count}} seneste søgninger fundet.",
  "removeFilter": "Fjern filteret »{{displayName}}«",
  "resultPreview": "resultatvisninger: {{value}}",
  "resultPreviewsFound_one": "{{count}} resultatvisning fundet.",
  "resultPreviewsFound_other": "{{count}} resultatvisninger fundet.",
  "resultsCountText_one": "{{count}} resultat",
  "resultsCountText_other": "{{count}} resultater",
  "resultsCountWithPaginationText": "{{paginateStart}} - {{paginateEnd}} af {{resultsCount}} resultater",
  "searchHere": "Søg her…",
  "showingAllInstead": "Viser i stedet alle {{currentVerticalLabel}}.",
  "showLess": "Vis mindre",
  "showMore": "Vis mere",
  "sources_one": "Kilde",
  "sources_other": "Kilder ({{count}})",
  "submitSearch": "Indsend søgning",
  "suggestionResultsCount_one": "{{label}} - {{count}} resultat",
  "suggestionResultsCount_other": "{{label}} - {{count}} resultater",
  "thankYouForYourFeedback": "Tak for din feedback!",
  "thisAnsweredMyQuestion": "Dette besvarede mit spørgsmål",
  "thisDidNotAnswerMyQuestion": "Dette besvarede ikke mit spørgsmål",
  "unselectAnOptionToEnterInARange": "Fravælg en mulighed for at indtaste et interval.",
  "updateYourLocation": "Opdater din placering",
  "useCurrentLocation": "Brug nuværende placering",
  "useMyLocation": "Brug min placering",
  "viewAll": "Se alle",
  "viewDetails": "Se detaljer"
}
